import React from "react";
import autonomoImg from "./autonomo.png";   

function Autonomo() {
  return (
    <img
      src={autonomoImg}      
      alt="Autonomo"     
    />
  );
}

export default Autonomo;
